<p-dialog [style]="{minWidth: '360px'}" [closeOnEscape]="false" [closable]="false" header="{{dialogTitle}}" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true" appendTo="body">
    <form class="validated-form admin-form" [formGroup]="form">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="grid">
          <div class="col-3">
            <label for="email">Email / Username</label>
          </div>
          <div class="col-9">
            <input [readonly]="!isNewUser" name="email" id="email" pInputText placeholder="email address" formControlName="email" />
            <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert-danger">
              <p *ngIf="email.errors.required">Email is required</p>
              <p *ngIf="email.errors.userNameTaken">A user with the email/username {{email.value}} already exists</p>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-3">
            <label for="role">Role</label>
          </div>
          <div class="col-9">
            <p-dropdown hideDropdownOnScroll id="role" name="role" [options]="availableRoles" formControlName="role" appendTo="body" placeholder="Select Role" [style]="{'width': '100%'}"></p-dropdown>
          </div>
        </div>



        <div *ngIf="limitedAccessRequired">

          <div class="grid">
            <div class="col-3">
              <label for="limitedBy">Limited By</label>
            </div>
            <div class="col-9">
              <p-selectButton id="limitedBy" name="limitedBy" optionLabel="name" [options]="limitedByOptions" formControlName="limitedBy"></p-selectButton>
            </div>
          </div>

          <div class="grid" *ngIf="isLimitedByClientRef">
            <div class="col-3">
              <label for="clients">{{limitedBy.value?.name}}</label>
            </div>
            <div class="col-9">
              <p-dropdown hideDropdownOnScroll formControlName="selectedClient" [filter]="true" filterBy="Ref,Name" id="clients" name="clients" [options]="clients" appendTo="body" dataKey="Ref" optionLabel="Name" placeholder="Select a {{limitedBy.value?.name}}" [style]="{'width': '100%'}"></p-dropdown>
            </div>
          </div>

          <div class="grid" *ngIf="isLimitedByClientParentRef">
            <div class="col-3">
              <label for="clientParents">{{limitedBy.value?.name}}</label>
            </div>
            <div class="col-9">
              <p-dropdown hideDropdownOnScroll formControlName="selectedClientParent" [filter]="true" filterBy="Id,Name" id="clientParents" name="clientParents" [options]="clientParents" appendTo="body" dataKey="Id" optionLabel="Name" placeholder="Select a {{limitedBy.value?.name}}" [style]="{'width': '100%'}"></p-dropdown>
            </div>
          </div>

        </div>

      </div>
    </form>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" [disabled]="!allowActions" pButton icon="fa-fw fa fa-close" (click)="cancel($event)" label="Cancel"></button>
      <button type="button" [disabled]="!allowActions || form.invalid || form.pristine"  pButton icon="fa-fw fa fa-check" (click)="save()" label="Save"></button>
      <button type="button" [disabled]="!allowActions || form.pristine" pButton icon="fa-fw fa fa-undo" (click)="reset()" label="Reset"></button>
    </div>
  </p-footer>
</p-dialog>
